/* Thalvore product page (info column, colour-matched gallery, stock line, tier box, sticky add to cart).
   Vanilla, deferred. Runs after theme.js has built theme.Product (theme.js inits sections as soon as it
   executes), so it works with the live Impulse instance instead of re-implementing it. */
(() => {
  const D = document, H = D.documentElement, W = window, VI = '[data-variant-input]';
  const on = (t, f, c) => D.addEventListener(t, f, c);
  const money = c => theme.Currency.formatMoney(c, theme.settings.moneyFormat);

  function init() {
    const R = D.querySelector('.tl-pdp');
    if (!R || R.tlOn) return;
    R.tlOn = 1;
    const $ = (s, e) => (e || R).querySelector(s), $$ = (s, e) => [...(e || R).querySelectorAll(s)];
    const ta = $('[data-variant-json]'), V = ta ? JSON.parse(ta.value) : [];
    const I = theme.sections && theme.sections._findInstance(R.dataset.sectionId), IV = I && I.variants;
    const btn = $('[data-add-to-cart]'), txt = $('[data-add-to-cart-text]'), st = $('[data-tl-sticky]'), inv = $('[data-product-inventory]'), iw = $('.tl-inv'), bd = $('[data-tl-save]');
    const sw = $('.tl-opt--size .variant-input-wrap'), si = sw && sw.dataset.index, thr = inv ? +inv.dataset.threshold : 0;
    const qty = v => { const r = v && v.inventory_management == 'shopify' && ((W.inventories || {})[R.dataset.productId] || {})[v.id]; return r ? r.quantity : 0 };
    const low = n => n > 0 && n <= thr;

    /* Gallery (handbook §5.2): when some media alt equals a colour value, drive Impulse's own image sets.
       Media with that alt + blank/"all" alt form the colour's group; a colour without matches shows all. */
    const sl = $$('[data-tl-alt]'), alts = sl.map(e => e.dataset.tlAlt); // main slides + thumbs
    const gw = IV && !I.settings.imageSetName && $$('.variant-input-wrap').find(w => $$(VI, w).some(i => alts.includes(i.value.toLowerCase())));
    if (gw) {
      const n = gw.dataset.handle, k = gw.dataset.index, box = $('[data-product-photos]');
      // Rebuild Impulse's slider on the colour's group, slides back in product order (Flickity's destroy re-appends its cells last).
      const set = v => {
        const x = v[k].toLowerCase(), g = n + '_' + I.getImageSetName(v[k]), all = !alts.includes(x);
        if (I.settings.currentImageSet == I.getImageSetName(v[k])) return;
        sl.forEach(e => { const a = e.dataset.tlAlt; e.dataset.setName = n; e.dataset.group = all || a == x || !a || a == 'all' ? g : 'tl-off' });
        if (I.flickity) I.flickity.destroy(), I.flickity = 0;
        $$('.product-main-slide', box).sort((a, b) => a.dataset.index - b.dataset.index).forEach(e => box.append(e));
        I.initProductSlider(v);
      };
      Object.assign(I.settings, { imageSetName: n, imageSetIndex: k });
      set(IV.currentVariant);
      R.addEventListener('variantChange', e => e.detail.variant && set(e.detail.variant));
      // A colour switch starts on slide 1: keep Impulse from jumping to the variant image afterwards.
      on('variantImageChange', e => { e.target == R && e.stopPropagation() }, true);
    }

    const S = k => st && $('[data-tl-sticky-' + k + ']', st);
    const sv = S('var'), sp = S('price'), sbp = S('bprice'), sc = S('compare'), sx = S('text'), sb = st && $('button', st), ss = st && $('select', st), sim = st && $('img', st);
    let chip;
    if (btn) {
      btn.dataset.tlAdded = st ? st.dataset.added : '';
      chip = D.createElement('span');
      chip.className = 'tl-atc-price';
      btn.append(chip);
    }

    const upd = v => {
      // Unavailable options: mirror Impulse's .disabled to aria-disabled.
      $$(VI).forEach(i => i.setAttribute('aria-disabled', i.classList.contains('disabled')));
      // Stock line: only tracked variants with 1..threshold left (.tl-stock-on), bar width --tl-w.
      if (iw && inv) {
        const n = qty(v), l = low(n);
        iw.classList.toggle('tl-stock-on', l);
        if (l) {
          iw.style.setProperty('--tl-w', n / thr * 100 + '%');
          if (si && st) inv.textContent = st.dataset.stock.replace('[size]', v[si]), inv.innerHTML = inv.innerHTML.replace('[count]', '<b>' + n + '</b>');
        }
      }
      // Gallery badge: "Save N%" of the selected variant, rounded down, hidden without compare-at.
      if (bd) {
        const p = v && v.compare_at_price > v.price ? (v.compare_at_price - v.price) * 100 / v.compare_at_price | 0 : 0;
        bd.hidden = p < 1;
        bd.textContent = bd.dataset.tlSave.replace('[p]', p);
      }
      // Low-stock dot on each size of the current selection.
      if (sw) {
        const sel = {};
        $$(VI + ':checked').forEach(i => sel[i.dataset.index] = i.value);
        $$(VI, sw).forEach(i => i.parentNode.classList.toggle('tl-low',
          low(qty(V.find(x => Object.keys(sel).every(k => x[k] == (k == si ? i.value : sel[k])))))));
      }
      if (chip) { chip.textContent = v ? money(v.price) : ''; chip.hidden = !v || !v.available }
      if (sb && btn) {
        const c = sw && $('input:checked', sw), f = v && v.featured_image;
        sb.disabled = btn.disabled;
        if (sbp) sbp.hidden = !v || !v.available;
        sx.textContent = txt.textContent.trim();
        if (v) {
          if (sv) sv.textContent = v.title;
          sp.textContent = money(v.price);
          if (sbp) sbp.textContent = money(v.price);
          sc.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : '';
        }
        if (sim && f) sim.src = f.src.replace(/\?|$/, '?width=96&');
        if (ss && c) ss.value = c.value;
      }
    };
    // theme.js fires this on document after all of its own container handlers.
    on('variant:change', e => { const v = e.detail.variant; if (!v || V.some(x => x.id == v.id)) upd(v) });
    R.addEventListener('change', e => {
      const t = e.target;
      if (t.classList.contains('variant__input--color-swatch') || (t.type == 'radio' && t.closest('.tl-opt--size'))) t.nextElementSibling.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
    });
    const sel = $('[data-product-select]');
    upd((IV && IV.currentVariant) || V.find(x => sel && x.id == sel.value));

    // Sticky bar: visible once the main button is above the viewport; never while the drawer is open
    // or while any part of the footer is on screen (it slides away instead of covering the footer).
    if (st && btn) {
      let past = 0, foot = 0;
      const show = () => {
        const on = past && !foot && !H.classList.contains('tl-cart-open');
        st.classList.toggle('is-on', on);
        st.inert = !on;
        st.setAttribute('aria-hidden', !on);
        H.classList.toggle('tl-sticky-on', on);
      };
      // The root reaches far below the viewport, so "not intersecting" means "above it", even after a jump.
      new IntersectionObserver(([e]) => { past = !e.isIntersecting && e.boundingClientRect.top < 0; show() }, { rootMargin: '0px 0px 99999px' }).observe(btn);
      const fv = new Set();
      const fo = new IntersectionObserver(es => { es.forEach(e => fv[e.isIntersecting ? 'add' : 'delete'](e.target)); foot = fv.size; show() });
      document.querySelectorAll('.shopify-section-group-footer-group').forEach(f => fo.observe(f));
      // tl-cart.js toggles html.tl-cart-open before it fires these.
      on('tl:cart:open', show);
      on('tl:cart:close', show);
      if (ss && sw) ss.addEventListener('change', () => {
        const r = $$(VI, sw).find(i => i.value == ss.value);
        if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })) }
      });
    }

    // Tier box: the one reached tier card + hint; all numbers come from data-* rendered by Liquid.
    const tb = $('[data-tl-tiers]');
    if (tb) {
      const h = JSON.parse(tb.dataset.hints), cs = $$('[data-qty]', tb), q = cs.map(c => +c.dataset.qty);
      const T = n => {
        const m = Math.max(0, ...q.filter(x => x <= n));
        cs.forEach((c, i) => c.classList.toggle('is-on', q[i] == m));
        $('[data-tl-tier-hint]', tb).innerHTML = h[Math.min(n, h.length - 1)];
      };
      fetch(theme.routes.cart).then(r => r.json()).then(c => T(c.item_count)).catch(() => {});
      on('tl:cart:updated', e => e.detail && T(e.detail.item_count));
    }
  }

  if (W.theme && theme.sections) init(); else on('DOMContentLoaded', init);
  on('shopify:section:load', init);
})();

/* Below-the-fold PDP behaviour.
   Review carousel (handbook §5.4); the trust-row dots live in tl-trust.js. The track is position:relative,
   so offsetLeft is measured relative to it. */
(() => {
  const still = matchMedia('(prefers-reduced-motion: reduce)');
  // Index of the child whose centre is nearest the scroller's centre.
  const near = (s, items) => {
    let c = s.scrollLeft + s.clientWidth / 2, best = 0, d = 1e9;
    items.forEach((el, i) => {
      const x = Math.abs(el.offsetLeft + el.offsetWidth / 2 - c);
      if (x < d) d = x, best = i;
    });
    return best;
  };
  const center = (s, el, smooth) => s.scrollTo({
    left: el.offsetLeft - (s.clientWidth - el.offsetWidth) / 2,
    behavior: smooth && !still.matches ? 'smooth' : 'auto'
  });
  const onScroll = (s, fn) => {
    let q;
    s.addEventListener('scroll', () => { q = q || requestAnimationFrame(() => { q = 0; fn(); }); }, { passive: true });
  };
  const mark = (dots, i) => dots.forEach((b, j) => {
    b.classList.toggle('is-on', i == j);
    b.setAttribute('aria-current', i == j);
  });

  const reviews = root => root.querySelectorAll('[data-tl-rv]').forEach(sec => {
    if (sec.dataset.tlOn) return;
    sec.dataset.tlOn = 1;
    const q = s => sec.querySelector(s);
    const tr = q('[data-tl-rv-track]'), cards = [...tr.children], last = cards.length - 1;
    const dots = [...sec.querySelectorAll('[data-tl-rv-dot]')], prev = q('[data-tl-rv-prev]'), next = q('[data-tl-rv-next]');
    let cur = 0, lock = -1, t, w = innerWidth;
    const show = i => {
      cur = i;
      mark(dots, i);
      if (prev) prev.disabled = !i, next.disabled = i == last;
    };
    // While a button-driven scroll runs, the target stays active (no dot flicker, and a quick
    // second click moves on from the target, so every click is exactly one card).
    const go = (i, smooth = 1) => {
      show(lock = Math.max(0, Math.min(last, i)));
      clearTimeout(t);
      t = setTimeout(() => { lock = -1; show(near(tr, cards)); }, 900);
      center(tr, cards[lock], smooth);
    };
    dots.forEach((b, i) => b.onclick = () => go(i));
    if (prev) prev.onclick = () => go(cur - 1), next.onclick = () => go(cur + 1);
    tr.onkeydown = e => {
      const k = { ArrowLeft: -1, ArrowRight: 1 }[e.key];
      if (k) e.preventDefault(), go(cur + k);
    };
    onScroll(tr, () => {
      const i = near(tr, cards);
      if (lock < 0 || i == lock) lock = -1, show(i);
    });
    // Keep the active card centred when the width changes (rotation), not on URL-bar resizes.
    addEventListener('resize', () => { if (w != innerWidth) w = innerWidth, center(tr, cards[cur]); });
    // With 3+ cards start on the 2nd, so a neighbour peeks in on both sides.
    go(last > 1 ? 1 : 0, 0);
  });

  const init = root => reviews(root);
  init(document);
  document.addEventListener('shopify:section:load', e => init(e.target));
  // Theme editor: selecting a Review block brings its card into view.
  document.addEventListener('shopify:block:select', e => {
    const card = e.target.closest && e.target.closest('.tl-rv__card'), tr = card && card.parentElement;
    if (tr && tr.matches('[data-tl-rv-track]')) center(tr, card, 1);
  });
})();

/* Colour and size row swipe cue: fade the right edge while more options are off-screen (handbook §5.3.6).
   The size row only scrolls on mobile (tl-pdp.css); on desktop it never overflows, so no fade. */
(() => {
  const init = () => document.querySelectorAll('.tl-opt--color .tl-opt-row, .tl-opt--size .tl-opt-row').forEach(r => {
    if (r.tlMore) return;
    r.tlMore = 1;
    const f = () => r.classList.toggle('tl-more', r.scrollLeft + r.clientWidth < r.scrollWidth - 2);
    f();
    r.addEventListener('scroll', f, { passive: true });
    addEventListener('resize', f);
  });
  document.readyState == 'loading' ? document.addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);
})();

/* Price block save badge: Impulse's updatePrice (theme.js) writes its own "You save …" text on every variant
   change. variantChange doesn't bubble, so catch it in the capture phase and re-apply the block's text/format
   (data-tl-save-text with [amount], data-tl-save-format) once Impulse's own listeners have run. */
(() => {
  document.addEventListener('variantChange', e => {
    const v = e.detail && e.detail.variant, box = e.target;
    const s = v && box.querySelector && box.querySelector('[data-tl-save-text]');
    if (!s) return;
    setTimeout(() => {
      if (!(v.compare_at_price > v.price)) return;
      const d = v.compare_at_price - v.price;
      const amt = s.dataset.tlSaveFormat == 'amount'
        ? theme.Currency.formatMoney(d, theme.settings.moneyFormat)
        : Math.round(d * 100 / v.compare_at_price) + '%';
      s.innerHTML = s.dataset.tlSaveText.replace(/&/g, '&amp;').replace(/</g, '&lt;').split('[amount]').join(amt);
    });
  }, true);
})();
